import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import EyeIcon from '../../ui/icons/EyeIcon'
import Tooltip from '../../ui/Tooltip'
import PhotoViewer from '../../ui/PhotoViewer'
import { formatDateTime } from '../../../utils/dateHelpers'

const VARIABLE_NAME = 'variable_name'
const ATTACHMENT_URL = 'attachment_url'
const ATTACHMENT_DOWNLOAD_URL = 'attachment_download_url'
const ATTACHMENT_FILENAME = 'attachment_filename'
const ATTACHMENT_CREATED_AT = 'attachment_created_at'

const CARD_CLASS = 'tw:flex tw:lg:w-1/2 tw:items-stretch tw:gap-3 tw:overflow-hidden tw:rounded-lg! '
  + 'tw:border tw:border-solid tw:border-gray-300 tw:bg-white tw:pr-3'
const THUMB_CLASS = 'tw:relative tw:w-12 tw:shrink-0 tw:border-r tw:border-solid tw:border-gray-300'
const EYE_CLASS = 'tw:flex tw:size-10 tw:shrink-0 tw:items-center tw:justify-center tw:border-0 '
  + 'tw:bg-transparent tw:cursor-pointer tw:text-2xl! tw:text-gray-600'

const PictureMarkField = ({ mark }) => {
  const { question } = mark
  const [viewing, setViewing] = useState(false)

  const url = question[ATTACHMENT_URL]
  const dynamic = Boolean(question[VARIABLE_NAME])
  const title = question[VARIABLE_NAME] || question[ATTACHMENT_FILENAME] || question.title
  const createdAt = question[ATTACHMENT_CREATED_AT]

  const openViewer = useCallback(() => setViewing(true), [])
  const closeViewer = useCallback(() => setViewing(false), [])

  if (!url) {
    return (
      <div className="tw:text-sm tw:text-gray-600">
        {dynamic ? 'Aucune image disponible pour cette variable' : 'Aucune image attachée à cette question'}
      </div>
    )
  }

  const viewerPhotos = [{ url, alt: title, downloadUrl: question[ATTACHMENT_DOWNLOAD_URL] }]

  return (
    <>
      <div className={CARD_CLASS}>
        <div className={THUMB_CLASS}>
          <img
            alt={title}
            className="tw:absolute tw:inset-0 tw:size-full tw:object-cover"
            src={url}
          />
        </div>
        <div className="tw:flex tw:flex-1 tw:min-w-0 tw:flex-col tw:justify-center tw:gap-0.5 tw:py-2">
          <span className="tw:truncate tw:text-sm tw:text-gray-950">{title}</span>
          {createdAt ? (
            <span className="tw:text-sm tw:text-gray-600">
              {`Importé le ${formatDateTime(createdAt)}`}
            </span>
          ) : null}
        </div>
        <Tooltip className="tw:flex tw:items-center tw:shrink-0 tw:self-center" content="Voir">
          <button aria-label="Voir l'image" className={EYE_CLASS} type="button" onClick={openViewer}>
            <EyeIcon />
          </button>
        </Tooltip>
      </div>
      <PhotoViewer isOpen={viewing} photos={viewerPhotos} onClose={closeViewer} />
    </>
  )
}

PictureMarkField.propTypes = {
  mark: PropTypes.shape({
    question: PropTypes.shape({
      [ATTACHMENT_CREATED_AT]: PropTypes.string,
      [ATTACHMENT_DOWNLOAD_URL]: PropTypes.string,
      [ATTACHMENT_FILENAME]: PropTypes.string,
      [ATTACHMENT_URL]: PropTypes.string,
      title: PropTypes.string,
      [VARIABLE_NAME]: PropTypes.string
    })
  }).isRequired
}

export default PictureMarkField
